import { useRef, useContext, useEffect, useState } from "react";
import SETTINGS from "../settings";
import classNames from "classnames";
import log from "loglevel";

import SitePlanContext from "../utils/siteplan-context";

import AutoHeightEmbed from "../components/auto-height-embed";
import Map, { Marker, Polygon, GoogleApiWrapper } from "google-maps-react";
import DebouncedSearch from "./debounced-search";

import { FA } from "../utils/font-awesome";

const MapDrawMarkers = (props) => {
  const sitePlanContext = useContext(SitePlanContext);
  const mapRef = useRef(null);

  const types = SETTINGS.MARKERS.TYPES;
  const [markerType, changeMarkerType] = useState(types[0]);

  const addMarker = (mapProps, map, clickEvent) => {
    sitePlanContext.updatePOIMarkers([
      ...sitePlanContext.poiMarkers,
      {
        name: markerType,
        latLng: { lat: clickEvent.latLng.lat(), lng: clickEvent.latLng.lng() },
      },
    ]);
  };

  const removeMarker = (mapProps, map, clickEvent) => {
    let updatedMarkers = [...sitePlanContext.poiMarkers];
    updatedMarkers.splice(mapProps.name, 1);
    sitePlanContext.updatePOIMarkers(updatedMarkers);
  };

  // control to recenter the map

  const recenterMap = () => {
    mapRef.current.map.fitBounds(sitePlanContext.boundBox.literal);
  };
  useEffect(recenterMap, [sitePlanContext.allSites.current]);

  const centerRef = useRef();
  const centerButton = (
    <span className="google-maps-button" ref={centerRef} onClick={recenterMap}>
      <FA icon="map-marked-alt" />
    </span>
  );

  const changeSearchText = (txt) => {
    log.info(txt);
  };
  const searchRef = useRef();
  const searchBar = (
    <span className="google-maps-search" ref={searchRef}>
      <DebouncedSearch placeholder="Search maps" onChange={changeSearchText} />
    </span>
  );

  const mapIsReady = () => {
    mapRef.current.map.controls[
      props.google.maps.ControlPosition.TOP_RIGHT
    ].push(centerRef.current);
    mapRef.current.map.controls[
      props.google.maps.ControlPosition.TOP_LEFT
    ].push(searchRef.current);
  };

  const MarkerTypeSelector = (props) => {
    return (
      <div className="marker-type-selector" {...props}>
        <div className="label">Add type:</div>
        {types.map((label, i) => {
          return (
            <div
              key={i}
              className={classNames(
                markerType == label ? "active" : "secondary",
                "button"
              )}
              onClick={() => {
                changeMarkerType(label);
              }}
            >
              {label}
            </div>
          );
        })}
        <div className="flexible-space"></div>
      </div>
    );
  };

  return (
    <>
      <MarkerTypeSelector show={props.show} />
      <AutoHeightEmbed>
        <Map
          google={props.google}
          onReady={mapIsReady}
          onClick={addMarker}
          scaleControl={true}
          streetViewControl={false}
          fullscreenControl={false}
          ref={mapRef}
        >
          {sitePlanContext.poiMarkers.map((coords, i) => {
            if (props.show.indexOf(coords.name) > -1 || !coords.name)
              return (
                <Marker
                  name={i}
                  label={coords.name}
                  position={coords.latLng}
                  key={i}
                  onClick={removeMarker}
                  animation={props.google.maps.Animation.DROP}
                />
              );
          })}
          {sitePlanContext.sitePlanCoords.length && (
            <Polygon
              paths={sitePlanContext.sitePlanCoords}
              strokeColor="#0000FF"
              strokeOpacity={0.6}
              strokeWeight={2}
              fillColor="#0000FF"
              fillOpacity={0.15}
              clickable={false}
            />
          )}
        </Map>
        {centerButton}
        {/* {searchBar} */}
      </AutoHeightEmbed>
    </>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyAraKWlMHCcvmJMIfo8fEcUNe6IEzv9VWs",
  libraries: ["geometry"],
})(MapDrawMarkers);
